<template>
	<v-container
		grid-list-xl
	>
		<v-layout
			row
			wrap
			align-center
			justify-center
		>
			<v-flex
				xs12
				md8
				pa-0
			>
				<slot name="alert" />
			</v-flex>
		</v-layout>
		<ProjectIterator
			:items="projects.models"
			@edit="setEditProject"
			@archive="archiveProject"
			@update-pagination="pagination = $event"
		/>
		<v-dialog
			ref="dialog"
			v-model="editProject.show"
			max-width="800px"
		>
			<v-card v-if="editProject.show">
				<EditProject
					:edit-project="editProject.project"
					:existing-projects="projects.getNames()"
					@saving-done="editProject.show = false"
					@cancel="editProject.show = false"
				/>
			</v-card>
		</v-dialog>
		<ArchivedProjects v-if="canViewArchived" />
		<Confirm ref="confirm" />
	</v-container>
</template>

<script>
import ProjectIterator from '@/components/Project/ProjectIterator';
import ArchivedProjects from '@/components/Project/ArchivedProjects';
import EditProject from '@/components/Project/EditProject';
import Confirm from '@/components/Confirm';

export default {
	components: {
		EditProject,
		ArchivedProjects,
		Confirm,
		ProjectIterator,
	},
	data() {
		return {
			editProject: { show: false, project: null },
		};
	},
	computed: {
		projects() {
			return this.$store.get('projects/active');
		},
		canViewArchived() {
			const permissions = this.$ls.get('permissions');

			return (permissions.indexOf('view_archived') > -1);
		},
	},
	methods: {
		/**
		 * Duplicate in @/views/Dashboard.vue
		 * @todo Find a way to put it in one place
		 */
		archiveProject(project) {
			const name = project.name;

			this.$refs.confirm.createConfirm(`This will archive "${name}".`, 'error')
				.then((answer) => {
					if (!answer) {
						return;
					}

					project.isArchived = true;
					project.save().then(() => {
						this.$store.dispatch('projects/archive', project);
						this.$notify('success', `Project "${name}" has been archived.`);
					}).catch((e) => {
						dump('Error archiving project', e);
						this.$notify('error', `Failed to archive project "${name}".`);
					});
				});
		},
		setEditProject(project) {
			this.editProject.project = project;
			this.editProject.show = true;
		},
	},
};
</script>

<style lang="scss" scoped>
.border--right {
	border-right: 1px solid grey;
}
</style>
